import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledFactDetailsComponent } from "./fact-details-component.scss";
import { convertToArrayIfNeeded } from "utils/arrays";
class FactDetailsComponent extends PureComponent {
    renderParagraphs(paragraphs) {
        return paragraphs.map((paragraph, index)=>/*#__PURE__*/ _jsx("div", {
                dangerouslySetInnerHTML: {
                    __html: paragraph
                }
            }, index));
    }
    render() {
        const { title, body } = this.props;
        let contentBody = convertToArrayIfNeeded(body);
        contentBody = this.renderParagraphs(contentBody);
        return /*#__PURE__*/ _jsxs(StyledFactDetailsComponent, {
            className: "fact-details-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "title",
                    children: title
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "content",
                    children: contentBody
                })
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
export { FactDetailsComponent as default };
